/**
 * Header Entry Point
 * @description 헤더 클라이언트 스크립트 통합 엔트리포인트
 *
 * 이 파일은 esbuild에 의해 IIFE 형식으로 번들링됩니다.
 * 헤더의 오버레이, 사이드 메뉴 등 모든 헤더 관련 기능을 초기화합니다.
 */

import { initHeader } from '../modules/header';

// 즉시 실행
initHeader();
